<template>
    <div class="login-container">
        <div class="o-page__card" style="padding-top:10%;">
            <el-alert class="u-mb-small"
                v-if="loginError"
                :title="loginError"
                type="error"
                show-icon>
            </el-alert>
            <div class="c-card u-mb-xsmall" v-loading="loggingIn">
                <h3 class="c-card__header header">BNI BV-Tools Monitoring Dashboard</h3>
                <!-- <p v-if="loginError">{{ loginError }}</p> -->
                <form class="c-card__body" @submit.prevent="loginSubmit">
                    <div class="c-field u-mb-small">
                        <label class="c-field__label" for="input1">Username</label>
                        <input class="c-input" type="text" v-model="username" placeholder="Username">
                    </div>
                    <div class="c-field has-icon-right u-mb-small">
                        <label class="c-field__label" for="input2">Password</label>
                        <input class="c-input" :type="passwordType" v-model="password" placeholder="Enter password">
                        <span class="c-field__icon" @click="switchVisibility"><i class="fa" :class="passwordType==='text'?'fa-eye':'fa-eye-slash'"></i></span>
                    </div>
                    <button class="c-btn c-btn--info c-btn--fullwidth" type="submit">Sign In</button>
                </form>
            </div>
            <div class="copyright-text">&copy; Copyright. Service Quality Unit</div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    export default {
        name: 'login',
        data() {
            return {
                username: '',
                password: '',
                passwordType: 'password'
            }
        },
        computed: {
            ...mapState([
                'loggingIn',
                'loginError'
            ])
        },
        methods: {
            ...mapActions([
                'doLogin'
            ]),
            switchVisibility() {
                this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
            },
            loginSubmit() {
                this.doLogin({
                    username: this.username,
                    password: this.password
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
.header {
    text-align: center;
}
.copyright-text {
    color: #fff;
    text-align: center;
}
</style>